import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface VideoPlayerModalData {
  title?: string;
  videoUrl: string;
}

@Component({
  selector: 'app-video-player-modal',
  templateUrl: './video-player-modal.component.html',
  styleUrls: ['./video-player-modal.component.scss']
})
export class VideoPlayerModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: VideoPlayerModalData,
    public dialogRef: MatDialogRef<VideoPlayerModalComponent>
  ) { }
}
